import { useForm } from '@felte/react';
import { useI18n } from '../utils/lni18n';
import ErrorLabel from './Error';
import classService, { userAtom } from '../utils/ClassService';
import { useAtom } from 'jotai';
import { CheckoutUserData } from '../utils/domain';

type userFormType = {
  firstname?: string,
  lastname?: string,
  email?: string,
  code?: string
}


function Userform() {

  const { languageService: t } = useI18n();
  const [currentUser] = useAtom(userAtom);

  const { form, errors, isValid } = useForm({

    onSubmit: (values:unknown) =>{
       console.log(values);

       // eslint-disable-next-line
       classService.goToCheckout(values as CheckoutUserData);



     },

    validate: async (values: userFormType) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const errors: any = {};

      if (!values.email || !/^[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/.test(values.email)) {
        errors.email = t.getText('bad_email_adress');
        classService.resetCurrentUser();
      }
      else {
        classService.checkEmail(values.email);
      }

      if (!values.code || values.code.length !== 5) {
        classService.resetCode();
        errors.code = [
          t.getText('code.wrong')
        ];
      } else {
        if (!(await classService.checkCode(values.code))) {
          errors.code = [
            t.getText('code.wrong')
          ];
        }
      }

      if (!values.firstname) errors.firstname = [
        t.getText('mail.noname')
      ];

      if (!values.lastname) errors.lastname = [
        t.getText('mail.noname')
      ];


      return errors;
    },
  });

  const sendCode = () => {
    classService.sendCode();
  }

  const gotocheckout = () => {

  }

  return (
    <>
      <form ref={form}>
        <div className="form-group">
          <label>{t.getText("firstname")}</label>
          <input className="form-control" name="firstname" placeholder="" type="text" required={true} />
          <ErrorLabel error={errors().firstname} />
        </div>


        <div className="form-group">
          <label>{t.getText("lastname")}</label>
          <input className="form-control" name="lastname" placeholder="" type="text" required={true} />
          <ErrorLabel error={errors().lastname} />
        </div>


        <div className="form-group">
          <label>{t.getText("mail")}</label>
          <input className="form-control" name="email" placeholder="" type="email" required={true} />
          <ErrorLabel error={errors().email} />
        </div>

        <div className='alert preserve-white alert-warning'>
          {t.getText("checkout.code.explain", currentUser.email)}

          <div className='mt-3 '>
            <button onClick={sendCode} disabled={currentUser.sendingEmail || !currentUser.status} type="button" className='btn btn-default'>{t.getText("send.code")}</button>
          </div>

          {currentUser.codeMessage && <div className='mt-2'>{currentUser.codeMessage}</div>}


          <div className="form-group mt-3">

            <label>{t.getText("code")}</label>
            <input className="form-control" name="code" placeholder="" type="text" required={true} />
            <ErrorLabel error={errors().code} />

          </div>
        </div>

        <input type="hidden" value={classService.currentClassId} name="classid" />

        <button onClick={gotocheckout} disabled={!isValid()} type="submit" className='btn btn-default'>{t.getText("next")}</button>

      </form>
    </>
  )
}

export default Userform
